import WebApi from "@/views/loyalty/shared/modules/web_api"

export class JustpayUserEndpoint {
    constructor () {
        this.url = `${process.env.VUE_APP_JUSTPAY_URL}api/user/`
        this.webApi = new WebApi()
    }

    async getUsers () {
        const users = await this.webApi.post(`${this.url}list`, { id: null, page: 1, limit: -1 })
        // console.log('users:', users)
        if (!users.status_code) {
            if (!users.error) {
                if (users) {
                    return users
                } else {
                    return null
                }
            } else {
                return null
            }
        } else {
            console.error(`Ошибка с кодом: ${users.status_code}`)
        }
    }

    async getForFiltering () {
        const users = await this.webApi.get(`${this.url}GetForFiltering`)
        // console.log('users:', users)
        if (!users.status_code) {
            if (!users.error) {
                if (users) {
                    return users
                } else {
                    return null
                }
            } else {
                return null
            }
        } else {
            console.error(`Ошибка с кодом: ${users.status_code}`)
        }
    }

    async headers (entity, headers) {
        const users = await this.webApi.post(`${this.url}headers`, { entity: entity, headers: headers })
        // console.log('users:', users)
        if (!users.status_code) {
            if (!users.error) {
                if (users) {
                    return users
                } else {
                    return null
                }
            } else {
                return null
            }
        } else {
            console.error(`Ошибка с кодом: ${users.status_code}`)
        }
    }
}
